import React from "react";
import CourseImage from "../../assets/images/course-img.jpg";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DummyAvatar from "../../assets/images/Profile-thumbnail-small.svg";
import User01 from "../../assets/images/instructor-img1.png";
import User02 from "../../assets/images/instructor-img2.png";
import User03 from "../../assets/images/instructor-img3.png";
import { Image } from "react-bootstrap";
import {
  createStudentFavoriteCourseApi,
  removeStudentFavoriteCourseApi,
} from "../../redux/features/studentDetailSlice";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

const StudentAllCourse = ({ activeCourse, courseDataList, datafetch }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const favouritesCourseHandler = async (id) => {
    const res = await dispatch(
      createStudentFavoriteCourseApi({ token: auth.token, courseId: id })
    ).unwrap();

    if (res.success) {
      toast.success(res?.message, {
        position: "top-center",
      });
      datafetch();
    }
  };

  const unfavoriteCourseHandler = async (id) => {
    const res = await dispatch(
      removeStudentFavoriteCourseApi({ token: auth.token, courseId: id })
    ).unwrap();

    if (res.success) {
      toast.success(res?.message, {
        position: "top-center",
      });

      datafetch();
    }
  };

  return (
    <>
      {courseDataList?.length > 0 ? (
        courseDataList?.map((enrollCourseItem) => {
          return (
            <div className="col-12 mb-12" key={enrollCourseItem?.id}>
              <article className="custum-course-card p-10 h-100 mb-0">
                <div className="mb-12">
                  <div className="img-holder mb-12">
                    <Link
                      to={`/student-courses-detail?id=${enrollCourseItem?.id}`}
                      className="text-decoration-none d-block"
                    >
                      <Image
                        src={
                          process.env.REACT_APP_GALLERY_URL +
                          JSON.parse(enrollCourseItem?.image_urls)?.[0]
                        }
                        alt={"Instructor"}
                        className="course-img img-fluid"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = CourseImage;
                        }}
                      />
                    </Link>
                    {enrollCourseItem?.favorites ? (
                      <span
                        className="course-fav-icon cursor-pointer"
                        style={{ background: "#F05203" }}
                        onClick={() =>
                          unfavoriteCourseHandler(enrollCourseItem?.id)
                        }
                      >
                        <svg
                          width="8"
                          height="8"
                          viewBox="0 0 8 8"
                          fill="#fff"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.01403 6.16674C3.91394 6.20207 3.74908 6.20207 3.64899 6.16674C2.79529 5.8753 0.887695 4.65951 0.887695 2.59884C0.887695 1.6892 1.62071 0.953247 2.52446 0.953247C3.06023 0.953247 3.53418 1.2123 3.83151 1.61266C4.12884 1.2123 4.60573 0.953247 5.13856 0.953247C6.04231 0.953247 6.77532 1.6892 6.77532 2.59884C6.77532 4.65951 4.86773 5.8753 4.01403 6.16674Z"
                            stroke="#fff"
                            strokeWidth="0.883144"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    ) : (
                      <span
                        className="course-fav-icon cursor-pointer"
                        onClick={() =>
                          favouritesCourseHandler(enrollCourseItem?.id)
                        }
                      >
                        <svg
                          width="8"
                          height="8"
                          viewBox="0 0 8 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.01403 6.16674C3.91394 6.20207 3.74908 6.20207 3.64899 6.16674C2.79529 5.8753 0.887695 4.65951 0.887695 2.59884C0.887695 1.6892 1.62071 0.953247 2.52446 0.953247C3.06023 0.953247 3.53418 1.2123 3.83151 1.61266C4.12884 1.2123 4.60573 0.953247 5.13856 0.953247C6.04231 0.953247 6.77532 1.6892 6.77532 2.59884C6.77532 4.65951 4.86773 5.8753 4.01403 6.16674Z"
                            stroke="#F05203"
                            strokeWidth="0.883144"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    )}
                  </div>
                </div>
                <div className="course-badge px-11 py-3 mb-10 d-inline-block">
                  {enrollCourseItem?.Category?.name || "No Category"}
                </div>
                <Link to={`/student-courses-detail?id=${enrollCourseItem?.id}`}>
                  <h5 className="ah-text-md text-black fw-bold text-capitalize mb-12">
                    {enrollCourseItem?.title || "Untitled Course"}
                  </h5>
                </Link>
                <div class="course-creator d-flex align-items-center">
                  <div class="creater-img">
                    <Image
                      src={
                        process.env.REACT_APP_GALLERY_URL +
                        enrollCourseItem?.instructor?.profile_picture
                      }
                      alt="Student Avatar"
                      className="w-100 h-100 object-fit-cover p-4 rounded-circle"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = DummyAvatar;
                      }}
                    />
                  </div>
                  <div class="creator-info ms-7">
                    <h5 class="ah-text-sm text-black fw-bold m-0 lh-sm text-capitalize">
                      {enrollCourseItem?.instructor?.full_name ||
                        "Instructor Name"}
                    </h5>
                    <span class="black-100-60 fw-normal lh-sm ah-text-xs">
                      Instructor
                    </span>
                  </div>
                </div>
              </article>
            </div>
          );
        })
      ) : (
        <div className="alert alert-info">No courses found</div>
      )}
    </>
  );
};

export default StudentAllCourse;
